import { useState } from "react";
import Finish from "./Finish";

const quizQuestions = [
  {
    id: 1,
    text: "What size pet do you prefer?",
    options: [
      "Small (Under 25 lbs)",
      "Medium (25-60 lbs)",
      "Large (Over 60 lbs)",
      "No Preference",
    ],
  },
  {
    id: 2,
    text: "How active are you?",
    options: [
      "Very Active",
      "Moderately Active",
      "Not Very Active",
      "Couch Potato",
    ],
  },
  {
    id: 3,
    text: "How much time can you dedicate daily?",
    options: [
      "Less than 1 hour",
      "1-3 hours",
      "3-5 hours",
      "More than 5 hours",
    ],
  },
  {
    id: 4,
    text: "What's your living situation?",
    options: ["Apartment", "House with yard", "Farm/Large Property", "Other"],
  },
  {
    id: 5,
    text: "Any experience with pets?",
    options: [
      "First-time owner",
      "Some experience",
      "Very experienced",
      "Professional",
    ],
  },
  {
    id: 6,
    text: "Do you have children?",
    options: [
      "No children",
      "Young children (0-5)",
      "Older children (6+)",
      "Teenagers",
    ],
  },
  {
    id: 7,
    text: "What's your noise tolerance?",
    options: [
      "Silent is golden",
      "Occasional sounds OK",
      "Moderate noise fine",
      "Noise doesn't bother me",
    ],
  },
  {
    id: 8,
    text: "Grooming commitment?",
    options: [
      "Minimal grooming",
      "Weekly brushing",
      "Regular grooming",
      "High maintenance is fine",
    ],
  },
  {
    id: 9,
    text: "Other pets at home?",
    options: [
      "No other pets",
      "Have dogs",
      "Have cats",
      "Multiple types of pets",
    ],
  },
  {
    id: 10,
    text: "Training interest?",
    options: [
      "Already trained only",
      "Basic training OK",
      "Love training activities",
      "Will hire trainer",
    ],
  },
  {
    id: 11,
    text: "Budget for pet care?",
    options: [
      "Budget conscious",
      "Moderate budget",
      "Comfortable budget",
      "No budget concerns",
    ],
  },
  {
    id: 12,
    text: "Preferred pet age?",
    options: [
      "Puppy/Kitten",
      "Young (1-3 years)",
      "Adult (3-7 years)",
      "Senior (7+ years)",
    ],
  },
];

export default function Quizz({ onComplete }) {
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [userAnswers, setUserAnswers] = useState([]);
  const [isQuizzComplete, setIsQuizzComplete] = useState(false);
  const [selectedAnswer, setSelectedAnswer] = useState(null);

  const handleChosenAnswer = (option) => {
    const newAnswers = [...userAnswers, option];
    setUserAnswers(newAnswers);
    setSelectedAnswer(option);

    if (currentQuestionIndex < quizQuestions.length - 1) {
      setCurrentQuestionIndex(currentQuestionIndex + 1);
      setSelectedAnswer(null);
    } else {
      setIsQuizzComplete(true);
    }
  };

  return (
    <>
      <div className="quiz-container">
        <h3 className="question-text">
          {quizQuestions[currentQuestionIndex].text}
        </h3>
        <div className="answer-buttons">
          {quizQuestions[currentQuestionIndex].options.map((option, index) => (
            <button
              onClick={() => handleChosenAnswer(option)}
              key={index}
              className={
                isQuizzComplete && selectedAnswer === option
                  ? "answer-button answer-active"
                  :  "answer-button"
              }
            >
              {option}
            </button>
          ))}
        </div>
        <div className="progress-section">
          <p className="progress-text">
            {quizQuestions[currentQuestionIndex].id} of {quizQuestions.length}
          </p>
          <div className="progress-bar">
            <div
              className="progress-fill"
              style={{
                width: `${
                  ((currentQuestionIndex + 1) / quizQuestions.length) * 100
                }%`,
              }}
            ></div>
          </div>
        </div>
      </div>

      {isQuizzComplete && <Finish onComplete={onComplete(userAnswers)} />}
    </>
  );
}
